const SET_STORY = 'comment/SET_STORY';

const SET_COMMUNITY_POST = 'comment/SET_COMMUNITY_POST';

const SET_FAN_ART = 'comment/SET_FAN_ART';

const SET_EPISODE = 'comment/SET_EPISODE';

const FETCH_COMMENTS = 'comment/FETCH_COMMENTS';

const FETCH_COMMENT = 'comment/FETCH_COMMENT';

const FETCH_COMMENT_ADD = 'comment/FETCH_COMMENT_ADD';

const FETCH_REPLY_COMMENTS = 'comment/FETCH_REPLY_COMMENTS';

const POST_COMMENT = 'comment/POST_COMMENT';

const POST_REPLY_COMMENT = 'comment/POST_REPLY_COMMENT';

const DELETE_COMMENT = 'comment/DELETE_COMMENT';

const HIDE_COMMENT = 'comment/HIDE_COMMENT';

const LIKE_COMMENT = 'comment/LIKE_COMMENT';

const FETCH_BEST_COMMENTS = 'comment/FETCH_BEST_COMMENTS';

const FETCH_FIXED_COMMENTS = 'comment/FETCH_FIXED_COMMENTS';

const LIKE_REPLY_TARGET_COMMENT = 'comment/LIKE_REPLY_TARGET_COMMENT';

const RESET = 'comment/RESET';

const RESET_REPLY_COMMENTS = 'comment/RESET_REPLY_COMMENTS';

export default {
  SET_STORY,
  SET_COMMUNITY_POST,
  SET_FAN_ART,
  SET_EPISODE,
  FETCH_COMMENTS,
  FETCH_COMMENT,
  FETCH_COMMENT_ADD,
  FETCH_REPLY_COMMENTS,
  POST_COMMENT,
  POST_REPLY_COMMENT,
  DELETE_COMMENT,
  HIDE_COMMENT,
  LIKE_COMMENT,
  FETCH_BEST_COMMENTS,
  FETCH_FIXED_COMMENTS,
  LIKE_REPLY_TARGET_COMMENT,
  RESET,
  RESET_REPLY_COMMENTS,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/comment/types.js